/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_Token_Warning_Blocked_Reliance_DescriptionInputs */

const en_shared_token_warning_blocked_reliance_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Reliance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This asset is flagged and should be reviewed before being relied on.`)
};

const de_shared_token_warning_blocked_reliance_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Reliance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Vermögenswert ist markiert und sollte überprüft werden, bevor man sich darauf verlässt.`)
};

const pt_br2_shared_token_warning_blocked_reliance_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Reliance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ativo está sinalizado e deve ser revisado antes de ser considerado confiável.`)
};

const tr_shared_token_warning_blocked_reliance_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Reliance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu varlık işaretlendi ve güvenilmeden önce incelenmelidir.`)
};

const zh_cn2_shared_token_warning_blocked_reliance_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Reliance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该资产已被标记，在依赖其数据前请先进行审核。`)
};

const zh_hk2_shared_token_warning_blocked_reliance_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Reliance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此資產已被標記，在依賴其資料前應先作檢視。`)
};

const ko_kr2_shared_token_warning_blocked_reliance_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Reliance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 자산은 플래그가 지정되어 있으므로 활용하기 전에 검토가 필요합니다.`)
};

const ru_ru2_shared_token_warning_blocked_reliance_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Reliance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот актив помечен, и его следует проверить, прежде чем полагаться на него.`)
};

const es_419_shared_token_warning_blocked_reliance_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Reliance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este activo está marcado y debe revisarse antes de depender de él.`)
};

/**
* | output |
* | --- |
* | "This asset is flagged and should be reviewed before being relied on." |
*
* @param {Shared_Token_Warning_Blocked_Reliance_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const shared_token_warning_blocked_reliance_description = /** @type {((inputs?: Shared_Token_Warning_Blocked_Reliance_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_Token_Warning_Blocked_Reliance_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_token_warning_blocked_reliance_description(inputs)
	if (locale === "de") return de_shared_token_warning_blocked_reliance_description(inputs)
	if (locale === "pt-BR") return pt_br2_shared_token_warning_blocked_reliance_description(inputs)
	if (locale === "tr") return tr_shared_token_warning_blocked_reliance_description(inputs)
	if (locale === "zh-CN") return zh_cn2_shared_token_warning_blocked_reliance_description(inputs)
	if (locale === "zh-HK") return zh_hk2_shared_token_warning_blocked_reliance_description(inputs)
	if (locale === "ko-KR") return ko_kr2_shared_token_warning_blocked_reliance_description(inputs)
	if (locale === "ru-RU") return ru_ru2_shared_token_warning_blocked_reliance_description(inputs)
	return es_419_shared_token_warning_blocked_reliance_description(inputs)
});